import React from 'react';
import { useTheme } from 'styled-components';

export function DropzoneBikeIcon() {
  const { colors } = useTheme();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="100"
      height="63"
    >
      <defs>
        <rect id="b" width="99" height="63" x="0" y="0" rx="5" />
        <rect id="c" width="99" height="63" x="0" y="0" rx="5" />
        <filter
          id="a"
          width="114.1%"
          height="122.2%"
          x="-7.1%"
          y="-7.9%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="2"
          />
          <feComposite
            in="shadowBlurOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0.0901960784 0 0 0 0 0.109803922 0 0 0 0 0.203921569 0 0 0 0.15 0"
          />
        </filter>
        <path
          id="e"
          d="M49.051 13.928c9.725 0 14.602 11.886 7.746 18.797C48.39 41.2 34.478 31.8 38.953 20.782c.488-1.244 2.554-5.322 4.36-3.558 1.865 1.822-2.265 2.545-2.265 7.722 0 7.172 8.663 10.787 13.683 5.726 5.05-5.09 1.463-13.795-5.68-13.795-1.893 0-1.893-2.95 0-2.95zm-35.227.376c1.864.52 1.09 3.354-.746 2.834-7.918-2.14-13.57 7.692-7.774 13.534 4.102 4.135 11.13 2.603 13.167-2.863.66-1.822 3.385-.78 2.725 1.012-2.782 7.461-12.335 9.601-17.958 3.904-7.889-7.924-.2-21.342 10.586-18.421zM41.19 2.534l9.208 21.834c.746 1.764-1.922 2.92-2.667 1.156l-6.225-14.778-9.209 11.424a4.397 4.397 0 01-.803 5.581l1.061 2.516c.89-.347 2.553-1.214 3.156.376.66 1.793-1.721 2.169-3.414 2.863-1.664.694-3.7 1.706-4.303.029-.574-1.504 1.033-1.938 1.807-2.227l-.975-2.4a4.37 4.37 0 01-4.332-2.863l-13.511.376c-1.205.029-1.894-1.388-1.177-2.343v-.029L20.68 9.59 18.9 5.368c-1.463.03-3.614.463-3.672-1.359-.057-2.14 2.926-1.388 4.189-1.59l5.307-.145c1.922-.058 2.008 2.863.086 2.92l-2.812.088 1.263 2.95L39.784 6.67l-1.262-2.979c-.344-.81-2.18-.954-3.04-.463-1.636.955-3.5-1.735-.919-2.805 2.21-.925 5.537-.376 6.627 2.111zm-19.192 10.15l-8.06 10.73 10.47-.29 1.205-1.88-3.615-8.56zM38.58 9.705l-14.114 1.36 3.816 9.022h.287c.516 0 1.004.087 1.463.232L38.58 9.705z"
        />
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(.5)">
        <use fill="#000" filter="url(#a)" xlinkHref="#b" />
        <rect
          width="97"
          height="61"
          x="1"
          y="1"
          fill="#FFF"
          stroke={colors.primary()}
          strokeLinejoin="square"
          strokeWidth="2"
          rx="5"
        />
        <g opacity=".1">
          <mask id="d" fill="#fff">
            <use xlinkHref="#c" />
          </mask>
          <path
            fill={colors.primary()}
            fillRule="nonzero"
            d="M0 50.506l11.382-3.03c1.727-.46 3.53-.558 5.297-.29l20.43 3.105c1.177.179 2.374.195 3.556.048l16.548-2.056c.906-.113 1.822-.13 2.732-.05L82.29 50.18a13.002 13.002 0 007.075-1.39L99 43.834V70H0V50.506z"
            mask="url(#d)"
          />
          <circle
            cx="14"
            cy="14"
            r="4"
            fill={colors.primary()}
            fillRule="nonzero"
            mask="url(#d)"
          />
        </g>
        <g transform="translate(20 14)">
          <mask id="f" fill="#fff">
            <use xlinkHref="#e" />
          </mask>
          <use fill="#000" fillRule="nonzero" xlinkHref="#e" />
          <g fill={colors.primary()} mask="url(#f)">
            <path d="M0-12h60v60H0z" />
          </g>
        </g>
      </g>
    </svg>
  );
}
